import { render, staticRenderFns } from "./addSync.vue?vue&type=template&id=00709a36&scoped=true"
import script from "./addSync.vue?vue&type=script&lang=js"
export * from "./addSync.vue?vue&type=script&lang=js"
import style0 from "./addSync.vue?vue&type=style&index=0&id=00709a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00709a36",
  null
  
)

export default component.exports